import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useFranchises } from "../../hooks/UseFranchises"; // Assumed existing hook.
import { EditFranchise } from "./EditFranchise";

export function EditFranchisePanel(props) {
    const [searchParams] = useSearchParams();
    const [franchiseId, setFranchiseId] = useState(searchParams.get('id'));
    const navigate = useNavigate();
    const useFranchisesHook = useFranchises();
    const user = props.user;

    const additionalContentRef = useRef(null);

    useEffect(() => {
        if (franchiseId) {
            useFranchisesHook.getById(user.token, franchiseId);
        }
    }, [user, franchiseId]);

    useEffect(() => {
        if (franchiseId && additionalContentRef.current) {
            const timer = setTimeout(() => {
                additionalContentRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 600);
            return () => clearTimeout(timer);
        }
    }, [franchiseId]);

    const onBackClicked = () => {
        navigate('/'); // Navigate to admin/dashboard or list.
    };

    const onSaveClicked = async (franchise) => {
        if (franchiseId) {
            await useFranchisesHook.update(user.token, franchise);
            alert('✅ Франшизу оновлено!');
        } else {
            const newFranchise = await useFranchisesHook.create(user.token, franchise);
            setFranchiseId(newFranchise.id);
            navigate(`/franchises/edit?id=${newFranchise.id}`, { replace: true });
            alert('🚀 Франшизу створено! Тепер можете додати сезони абощо.');
        }
    };

    const onDeleteClicked = async (franchise) => {
        if (window.confirm("Ви точно хочете видалити цю франшизу?")) {
            await useFranchisesHook.deleteFranchise(user.token, franchise);
            navigate(`/`, { replace: true });
        }
    };

    return (
        <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh', padding: '20px 10px' }}>
            {/* Navigation */}
            <div style={{ maxWidth: '900px', margin: '0 auto 20px auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                        onClick={onBackClicked}
                        style={{
                            padding: '10px 20px',
                            borderRadius: '8px',
                            border: '1px solid #d1d5db',
                            backgroundColor: '#fff',
                            cursor: 'pointer',
                            fontWeight: '600',
                            color: '#374151',
                            transition: 'all 0.2s',
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#f9fafb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#fff'}
                    >
                        ← До адмінки
                    </button>

                    <button
                        onClick={() => navigate('/franchises')}
                        style={{
                            padding: '10px 20px',
                            borderRadius: '8px',
                            border: '1px solid #e0e7ff',
                            backgroundColor: '#eef2ff',
                            color: '#4f46e5',
                            cursor: 'pointer',
                            fontWeight: '600',
                            transition: 'all 0.2s',
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#e0e7ff'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#eef2ff'}
                    >
                        📋 До франшиз
                    </button>
                </div>

                <div style={{ textAlign: 'right' }}>
                    <h2 style={{ margin: 0, color: '#111827' }}>
                        {franchiseId ? 'Редагування франшизи' : 'Створення франшизи'}
                    </h2>
                    <small style={{ color: '#6b7280' }}>ID: {franchiseId || 'new'}</small>
                </div>
            </div>

            {/* Edit Form */}
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '24px',
                    marginBottom: '24px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                    border: '1px solid #e5e7eb',
                }}>
                    <h3 style={{
                        marginTop: 0,
                        marginBottom: '20px',
                        fontSize: '1.25rem',
                        color: '#1f2937',
                        borderBottom: '2px solid #f3f4f6',
                        paddingBottom: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                    }}>
                        📝 Інформація про франшизу
                    </h3>
                    <EditFranchise
                        user={user}
                        franchise={useFranchisesHook.franchise}
                        onSaveClicked={onSaveClicked}
                        onDeleteClicked={onDeleteClicked}
                    />
                </div>

                {/* Additional Panels for Related Data */}
                {franchiseId && (
                    <div ref={additionalContentRef}>
                        {/* Add panels here for related serials or genres, if needed */}
                    </div>
                )}
            </div>
        </div>
    );
}